import { render, staticRenderFns } from "./SnaqView.vue?vue&type=template&id=7a9c6a4a&"
import script from "./SnaqView.vue?vue&type=script&lang=ts&"
export * from "./SnaqView.vue?vue&type=script&lang=ts&"
import style0 from "./SnaqView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports